/*
 * frete-cotacao.js — window.WoolieFrete
 *
 * POR QUE ESTE ARQUIVO EXISTE
 *
 * O tema acumulou seis copias do mesmo calculo de frete: o calculador antigo, a
 * PDP v3, a pagina da Duna, a LP dos Bites, a LP de Sao Paulo e o helper de
 * prazo. Cada correcao precisava ser feita seis vezes, e nunca era: o bug da
 * Torre Santorini (cotar o CARRINHO em vez do produto) foi corrigido na v3 em
 * julho e continuava vivo na Duna. Tres copias ainda chamavam /cart/clear.js,
 * que esvazia o carrinho INTEIRO do cliente.
 *
 * Todas essas telas agora compartilham CEP, tarifas e a transacao de produto.
 * Consultas simultaneas identicas compartilham a mesma promessa. A calculadora
 * antiga tambem usa este modulo, mantendo seu HTML e suas mensagens de prazo.
 *
 * O QUE ESTE MODULO GARANTE, EM QUALQUER TELA
 *
 * 1. O item que o cliente esta prestes a comprar entra na cotacao SEMPRE, somado
 *    ao carrinho. Nunca existe "so se o carrinho estiver vazio": era isso que
 *    fazia um movel de R$ 3.350 exibir a tarifa de uma encomenda pequena.
 * 2. A limpeza remove exatamente o que foi adicionado, por /cart/change.js.
 *    Nunca /cart/clear.js.
 * 3. O item e congelado no clique: o que itemParaCotar() devolveu e o que vai
 *    para o add, para o texto e para a limpeza, mexa o cliente no que mexer
 *    durante os segundos da cotacao.
 * 4. Fila global por aba. Produtos diferentes aguardam a limpeza anterior e
 *    consultas identicas compartilham a transacao em andamento.
 * 5. A COTACAO MANDA. Tarifa com preco zero e frete gratis, ponto. Quando a
 *    conta diz que passou do limiar mas nenhuma tarifa veio zerada, o texto NAO
 *    afirma gratuidade: prometer o que o checkout desmente e pior que nao
 *    prometer.
 *
 * Enderecos: window.WoolieCep (cep-consulta.js). Carrinho: window.WoolieCart.
 * Formatacao usa window.freteDedupeRates e
 * window.fretePrazoChegada (frete-prazo.js), window.WoolieFreteMeta (barra do
 * carrinho). Nada de helper privado de secao.
 */
(function () {
  'use strict';

  var UF = {
    AC: 'Acre', AL: 'Alagoas', AM: 'Amazonas', AP: 'Amapá', BA: 'Bahia', CE: 'Ceará',
    DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás', MA: 'Maranhão',
    MG: 'Minas Gerais', MS: 'Mato Grosso do Sul', MT: 'Mato Grosso', PA: 'Pará',
    PB: 'Paraíba', PE: 'Pernambuco', PI: 'Piauí', PR: 'Paraná', RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte', RO: 'Rondônia', RR: 'Roraima', RS: 'Rio Grande do Sul',
    SC: 'Santa Catarina', SE: 'Sergipe', SP: 'São Paulo', TO: 'Tocantins'
  };

  function money(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    return 'R$ ' + parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
  }

  function makeEl(tag, opts) {
    var e = document.createElement(tag);
    opts = opts || {};
    if (opts.className) e.className = opts.className;
    if (opts.text != null) e.textContent = opts.text;
    return e;
  }

  function montaFrase(el, partes) {
    if (!el) return;
    el.replaceChildren();
    partes.forEach(function (p) {
      if (p.b) el.appendChild(makeEl('strong', { text: p.b }));
      else if (p.nota) el.appendChild(makeEl('span', { className: 'p-shipinfo__nota', text: p.nota }));
      else el.appendChild(document.createTextNode(p.t));
    });
  }

  function regrasPadrao() {
    var el = document.getElementById('WoolieFreteRegras');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* Acha no carrinho a linha equivalente a `alvo` SEM depender da key: a Shopify
     recalcula o hash quando o item funde numa linha existente. Medido nesta loja,
     a mesma linha saiu de ...37d7d903 para ...a32dc633 entre o /cart.js e a
     resposta do add. Procurar pela key errava o alvo e zerava a linha do cliente.
     Variante + plano + propriedades e exatamente o criterio de merge da Shopify. */
  function achaLinha(cart, alvo) {
    if (!cart || !cart.items || !alvo) return null;
    function plano(i) {
      return (i && i.selling_plan_allocation && i.selling_plan_allocation.selling_plan &&
              i.selling_plan_allocation.selling_plan.id) || null;
    }
    function props(i) {
      var p = (i && i.properties) || {};
      return Object.keys(p).sort().map(function (k) { return k + '=' + p[k]; }).join('&');
    }
    var pAlvo = plano(alvo), prAlvo = props(alvo);
    for (var k = 0; k < cart.items.length; k++) {
      var i = cart.items[k];
      if (String(i.id) === String(alvo.id) && String(plano(i) || '') === String(pAlvo || '') && props(i) === prAlvo) return i;
    }
    return null;
  }

  function normalizaTarifa(rt) {
    var chegada = (window.fretePrazoChegada && window.fretePrazoChegada(rt)) || '';
    // O texto do prazo mora em frete-prazo.js (window.fretePrazoDias), que é
    // carregado antes deste no head. Este arquivo montava a frase por conta
    // própria, igualzinho ao shipping-calculator.js, e as duas cópias tinham que
    // ser corrigidas em par — o que não acontecia.
    var dias = chegada ? '' : ((window.fretePrazoDias && window.fretePrazoDias(rt)) || '');
    var centavos = Math.round(Number(rt.price) * 100);
    return { nome: rt.presentment_name, chegada: chegada, dias: dias,
             precoCentavos: centavos, gratis: centavos === 0, raw: rt };
  }

  // The cart is shared by every widget. Serialize different quotes so a cart-only
  // request can never see the temporary product from another calculator. Exact
  // simultaneous requests share their promise, including the add/remove cycle.
  var fila = Promise.resolve(), pedidos = new Map(), tarifasCache = new Map();
  var eventosCarrinho = 0, limpezaPendente = null;
  var CACHE_MS = 30000;

  function revisao() {
    return eventosCarrinho + ':' + (window.WoolieCart ? window.WoolieCart.revision() : 0);
  }
  function invalidar() { tarifasCache.clear(); }
  function mudouCarrinho() {
    var antes = revisao();
    invalidar();
    if (window.WoolieCart) window.WoolieCart.invalidate();
    var depois = revisao();
    // Our own probe does not turn an identical pending quote into a new job.
    // A customer mutation still changes the revision and cannot join old work.
    acompanharRevisao(antes, depois);
  }
  function acompanharRevisao(antes, depois) {
    pedidos.forEach(function (pedido) { if (pedido.versao === antes) pedido.versao = depois; });
  }
  function escrever(url, body) {
    mudouCarrinho();
    var antes = revisao();
    var request = fetch(url, post(body));
    // Gift and other cart integrations invalidate synchronously inside fetch.
    // These invalidations belong to this write, just like our own invalidation.
    acompanharRevisao(antes, revisao());
    return request;
  }
  function lerCarrinho() {
    return window.WoolieCart ? window.WoolieCart.getCart() : json('/cart.js');
  }
  function falha(motivo) { var e = new Error(motivo); e.motivo = motivo; return e; }
  function json(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw falha('rede');
      return response.json();
    });
  }
  function post(body) {
    return { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) };
  }
  function assinatura(cart) {
    // Include prices, discounts, plans, properties, weights and attributes, not
    // only item_count. Sections contain HTML and do not affect the shipping quote.
    var state = Object.assign({}, cart);
    delete state.sections;
    return JSON.stringify(state);
  }
  function avisar(cart) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'frete-cotacao', cartData: cart });
      }
    } catch (e) {}
  }
  async function limpar(alvo) {
    // A failed change may already have succeeded at the server. Re-read before
    // retrying; never subtract from another line or restore a stale quantity.
    for (var tentativa = 0; tentativa < 2; tentativa++) {
      try {
        mudouCarrinho();
        var cart = await lerCarrinho();
        var linha = achaLinha(cart, alvo), removidas = 0;
        // Shopify can split a single add into several lines because of pricing
        // or discounts. Remove every line with this transaction's unique marker.
        while (linha) {
          if (++removidas > 100) throw falha('limpeza');
          var response = await escrever('/cart/change.js', { id: linha.key, quantity: 0 });
          if (!response.ok) throw falha('rede');
          cart = await response.json();
          if (!cart || !Array.isArray(cart.items)) throw falha('rede');
          var seguinte = achaLinha(cart, alvo);
          if (seguinte && seguinte.key === linha.key && seguinte.quantity >= linha.quantity) throw falha('limpeza');
          linha = seguinte;
        }
        limpezaPendente = null;
        return cart;
      } catch (e) { if (tentativa === 1) throw falha('limpeza'); }
    }
  }

  async function executar(cep, item, regras) {
    var alvo = null, resultado, cartFinal = null, versao, eventosInicio, snapshot;
    try {
      if (limpezaPendente) { cartFinal = await limpar(limpezaPendente); avisar(cartFinal); }
      var via = await window.WoolieCep.consultar(cep);
      // Only a confirmed address can select the cart's free-shipping region.
      if (window.WoolieFreteMeta) window.WoolieFreteMeta.guardarCep(cep);
      snapshot = await lerCarrinho();
      versao = revisao();
      eventosInicio = eventosCarrinho;
      var chave = cep + ':' + assinatura(snapshot);
      var hit = !item && tarifasCache.get(chave);
      var rates;
      if (hit && hit.versao === versao && hit.expires > Date.now()) {
        rates = JSON.parse(JSON.stringify(hit.rates));
      } else {
        if (item) {
          // A unique private property keeps this probe separate from both the
          // customer's purchases and a previous request whose cleanup failed.
          var marker = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
          var body = { id: item.id, quantity: item.quantity || 1, properties: { _cotacao_frete: marker } };
          if (item.selling_plan) body.selling_plan = item.selling_plan;
          alvo = { id: item.id, properties: body.properties };
          if (item.selling_plan) alvo.selling_plan_allocation = { selling_plan: { id: item.selling_plan } };
          limpezaPendente = alvo;
          var adding = escrever('/cart/add.js', { items: [body] });
          versao = revisao();
          var response = await adding;
          // Shopify can add the available units and still return 422. Keep the
          // unique target so even a refused/partial add is verified and cleaned.
          if (!response.ok) throw falha('indisponivel');
          var added = await response.json();
          if (!added || !added.items || !added.items[0]) throw falha('rede');
          if (window.WoolieFreteMeta && item.price) window.WoolieFreteMeta.proxy(item.price * (item.quantity || 1));
        }
        if (versao !== revisao()) throw falha('alterado');
        var resp = await json('/cart/shipping_rates.json?shipping_address[zip]=' + cep +
          '&shipping_address[country]=Brazil&shipping_address[province]=' + encodeURIComponent(UF[via.uf] || ''));
        if (versao !== revisao()) throw falha('alterado');
        rates = resp.shipping_rates || [];
        if (window.freteDedupeRates) rates = window.freteDedupeRates(rates);
        if (!rates.length) throw falha('sem_tarifas');
        if (!item) {
          tarifasCache.clear(); // bounded: only the most recent cart/address quote
          tarifasCache.set(chave, { rates: rates, versao: versao, expires: Date.now() + CACHE_MS });
        }
      }
      var tarifas = rates.map(normalizaTarifa);
      var ehSP = cep.charAt(0) === '0';
      var subCarrinho = snapshot.total_price || 0;
      var soEsteItem = item ? (item.price || 0) * (item.quantity || 1) : 0;
      resultado = {
        ok: true, cep: cep, uf: via.uf, provincia: UF[via.uf] || '',
        localidade: via.localidade, bairro: via.bairro, tarifas: tarifas,
        gratis: tarifas.some(function (t) { return t.gratis; }),
        carrinho: snapshot, item: item, ehSP: ehSP,
        limiarCentavos: ehSP ? (regras && regras.sp) : null,
        desconto: !ehSP && regras ? regras.desconto : null,
        subtotalCarrinho: subCarrinho, baseCentavos: subCarrinho + soEsteItem, soEsteItem: soEsteItem
      };
    } catch (e) {
      resultado = { ok: false, motivo: e.motivo || 'rede' };
    } finally {
      if (alvo) {
        try { cartFinal = await limpar(alvo); }
        catch (e) { resultado = { ok: false, motivo: 'limpeza' }; }
        if (window.WoolieFreteMeta) window.WoolieFreteMeta.proxy(0);
        if (resultado.ok && eventosInicio !== eventosCarrinho) resultado = { ok: false, motivo: 'alterado' };
        avisar(cartFinal);
      }
    }
    return resultado;
  }

  function cotar(valor, opts) {
    opts = opts || {};
    var cep = String(valor || '').replace(/\D/g, '');
    if (cep.length !== 8) return Promise.resolve({ ok: false, motivo: 'cep' });
    // Freeze the selected variant/quantity/plan now, before another quote can put
    // this one in the queue. Later UI changes must not change its cleanup target.
    var item = typeof opts.itemParaCotar === 'function' ? opts.itemParaCotar() : null;
    item = item ? JSON.parse(JSON.stringify(item)) : null;
    var regras = opts.regras || regrasPadrao();
    var chave = JSON.stringify([cep, item, regras]);
    var existente = pedidos.get(chave);
    if (existente && existente.versao === revisao()) return existente.promise;
    var pedido = { versao: revisao() };
    pedido.promise = fila.then(function () { return executar(cep, item, regras); })
      .catch(function () { return { ok: false, motivo: 'rede' }; });
    fila = pedido.promise;
    pedidos.set(chave, pedido);
    pedido.promise.finally(function () { if (pedidos.get(chave) === pedido) pedidos.delete(chave); });
    return pedido.promise;
  }

  function observarCarrinho() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        invalidar();
        if (!event || event.source !== 'frete-cotacao') eventosCarrinho += 1;
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observarCarrinho);
  else observarCarrinho();

  /* ---------- renderers: o texto da v3, movido sem reescrever ---------- */

  function renderTarifas(saida, r) {
    if (!saida) return;
    saida.replaceChildren();
    var ul = makeEl('ul');
    r.tarifas.forEach(function (t) {
      var li = makeEl('li');
      var span = makeEl('span', { text: t.nome + (t.chegada || t.dias ? ' · ' : '') });
      if (t.chegada) span.appendChild(makeEl('span', { className: 'frete-chega', text: t.chegada }));
      else if (t.dias) span.appendChild(document.createTextNode(t.dias));
      li.appendChild(span);
      li.appendChild(makeEl('strong', { text: t.gratis ? 'Grátis' : money(t.precoCentavos) }));
      ul.appendChild(li);
    });
    saida.appendChild(ul);
  }

  function setBarra(el, pct) {
    if (!el) return;
    if (pct === null) { el.hidden = true; return; }
    el.hidden = false;
    var v = Math.max(0, Math.min(100, pct));
    if (el.firstElementChild) el.firstElementChild.style.width = v + '%';
    el.setAttribute('aria-valuenow', String(v));
  }

  function renderMeta(meta, r) {
    if (!meta || !meta.caixa || (!r.limiarCentavos && !r.desconto)) return;
    meta.caixa.hidden = false;

    if (r.gratis) {
      // A cotacao inclui o carrinho inteiro, entao um produto barato pode sair
      // "gratis" as custas do que o cliente ja tinha. Dizer so "frete gratis"
      // faria ele entender que o beneficio e DESTE produto, e sumiria no dia em
      // que voltasse com o carrinho vazio.
      if (r.subtotalCarrinho > 0 && r.soEsteItem > 0 && r.soEsteItem < r.limiarCentavos) {
        montaFrase(meta.texto, [
          { b: 'Frete grátis' }, { t: ' para este CEP, somando os ' },
          { b: money(r.subtotalCarrinho) }, { t: ' que já estão no seu carrinho.' }
        ]);
      } else {
        montaFrase(meta.texto, [{ b: 'Frete grátis' }, { t: ' para este CEP.' }]);
      }
      setBarra(meta.barra, 100);
      return;
    }

    // Fora de SP capital e Grande SP: desconto progressivo, sem meta de gratuidade.
    // O preco que a lista de tarifas acima ja mostra vem do gateway COM o desconto
    // aplicado, entao aqui a frase so aponta a proxima faixa. Nenhum valor de
    // desconto e prometido pelo site.
    if (r.desconto) {
      var d = r.desconto;
      if (r.baseCentavos < d.inicio) {
        var faltaInicio = [{ t: 'Faltam ' }, { b: money(d.inicio - r.baseCentavos) },
                           { t: ' para o frete ter desconto neste CEP' }];
        if (r.subtotalCarrinho > 0) {
          faltaInicio.push({ t: ', já somando os ' }, { b: money(r.subtotalCarrinho) }, { t: ' do seu carrinho.' });
        } else {
          faltaInicio.push({ t: '.' });
        }
        montaFrase(meta.texto, faltaInicio);
        setBarra(meta.barra, Math.min(99, Math.round((r.baseCentavos / d.inicio) * 100)));
        return;
      }
      var andado = (r.baseCentavos - d.inicio) % d.passo;
      montaFrase(meta.texto, [
        { t: 'Faltam ' }, { b: money(d.passo - andado) },
        { t: ' para aumentar o desconto do frete neste CEP.' }
      ]);
      setBarra(meta.barra, Math.min(99, Math.round((andado / d.passo) * 100)));
      return;
    }

    if (r.baseCentavos >= r.limiarCentavos) {
      montaFrase(meta.texto, [
        { t: 'Seu carrinho já passa de ' }, { b: money(r.limiarCentavos) },
        { t: '. O valor final do frete aparece no checkout.' }
      ]);
      setBarra(meta.barra, 100);
      return;
    }

    var partes = [{ t: 'Faltam ' }, { b: money(r.limiarCentavos - r.baseCentavos) },
                  { t: ' para o frete grátis neste CEP' }];
    if (r.subtotalCarrinho > 0) {
      partes.push({ t: ', já somando os ' }, { b: money(r.subtotalCarrinho) }, { t: ' do seu carrinho.' });
    } else {
      partes.push({ t: '.' });
    }
    montaFrase(meta.texto, partes);
    // Trava em 99% enquanto falta dinheiro: Math.round devolve 100 a partir de
    // 99,5%, e barra cheia embaixo de "Faltam R$ 2,00" e contradicao na tela.
    setBarra(meta.barra, Math.min(99, Math.round((r.baseCentavos / r.limiarCentavos) * 100)));
  }

  /* ---------- widget ---------- */

  var FRASES = {
    curto: 'Digite um CEP válido.',
    calculando: 'Calculando…',
    // 'cep' e 'rede' caem na mesma frase DE PROPOSITO: e o texto que ja esta no ar,
    // porque a v3 jogava os dois no mesmo .catch. Separar seria mudanca de copy
    // disfarcada de refatoracao, e o harness antes x depois pegou justamente isso
    // quando eu escrevi diferente aqui.
    //
    // 'sem_tarifas' e outra coisa: o CEP existe, a consulta funcionou e o
    // transportador nao devolveu opcao. A v3 ja tinha frase propria para isso.
    cep: 'Não foi possível calcular agora. Tente de novo.',
    rede: 'Não foi possível calcular agora. Tente de novo.',
    sem_tarifas: 'CEP não localizado. Confirme o frete no checkout.',
    // Nao manda tentar de novo: a recusa do add e deterministica (esgotado, ou
    // quantidade acima do estoque) e nenhuma tentativa vai funcionar.
    indisponivel: 'Não dá para calcular o frete deste item agora. Confira a disponibilidade e a quantidade.',
    ocupado: 'Calculando…',
    alterado: 'Seu carrinho mudou. Calcule novamente o frete.',
    limpeza: 'Não foi possível concluir o cálculo. Tente de novo antes de finalizar a compra.'
  };

  function ligar(nos, opcoes) {
    opcoes = opcoes || {};
    var input = nos.input, botao = nos.botao, saida = nos.saida, meta = nos.meta || null;
    if (!input || !botao || !saida) return null;
    // Idempotente por no: o drawer e as secoes do editor de tema reexecutam o
    // script sobre o mesmo DOM, e sem isto cada passada somava um listener.
    if (input.dataset.freteLigado) return null;
    input.dataset.freteLigado = '1';

    function mascara() {
      var d = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
    }

    function esconderMeta() { if (meta && meta.caixa) meta.caixa.hidden = true; }

    var sequencia = 0;
    function calcular() {
      var pedidoAtual = ++sequencia;
      var cep = input.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        botao.removeAttribute('disabled');
        esconderMeta();
        saida.textContent = FRASES.curto;
        return;
      }
      botao.setAttribute('disabled', '');
      saida.textContent = FRASES.calculando;
      // Esconde o resultado anterior: sem isto, trocar de CEP mantinha a barra e
      // o texto da consulta passada na tela enquanto a nova carregava, e o
      // cliente lia "frete grátis" de um CEP que nao era mais o dele.
      esconderMeta();

      cotar(cep, opcoes).then(function (r) {
        if (pedidoAtual !== sequencia) return;
        botao.removeAttribute('disabled');
        var atual = typeof opcoes.itemParaCotar === 'function' ? opcoes.itemParaCotar() : null;
        if (input.value.replace(/\D/g, '') !== cep || (r.ok && JSON.stringify(atual) !== JSON.stringify(r.item))) {
          saida.textContent = 'Sua seleção mudou. Calcule novamente o frete.';
          return;
        }
        if (!r.ok) { saida.textContent = FRASES[r.motivo] || FRASES.rede; return; }
        renderTarifas(saida, r);
        if (meta) renderMeta(meta, r);
        if (typeof opcoes.aoCotar === 'function') opcoes.aoCotar(r);
      });
    }

    input.addEventListener('input', mascara);
    input.addEventListener('keyup', function (e) { if (e.key === 'Enter') calcular(); });
    botao.addEventListener('click', calcular);

    return { esconderMeta: esconderMeta, calcular: calcular };
  }

  window.WoolieFrete = {
    cotar: cotar,
    mensagens: FRASES,
    ligar: ligar,
    money: money,
    render: { tarifas: renderTarifas, meta: renderMeta }
  };
})();
